module.exports = __webpack_public_path__ + "img/delete.8bb7b873.svg";